import { VehicleQuestionModel } from '../vehicle-question.model';

export class VehicleRegistrationData {
  vin: string;
  technicalInspectionDate: Date;
  questions: VehicleQuestionModel[];

  constructor() {
    this.questions = [];
  }
}
